module.exports = __webpack_public_path__ + "img/structure-organization-4.b51cc957.jpg";